<template>
  <v-app id="inspire">
    <div class="staff-list-wrap">
      <div>
        <v-layout class="wrap header-shifts-table mb-4">
          <h2 class="headline">Staff List</h2>
          <v-spacer></v-spacer>
          <v-btn
            class="ma-0"
            text
            small
            :loading="exportCsvLoading"
            :disabled="exportCsvLoading"
            @click="exportCsv"
          ><v-icon class="mr-1">cloud_download</v-icon> CSV
        </v-btn>
      </v-layout>
      </div>
      <v-flex class="header-search-single">
        <v-layout>
          <v-flex xs6 class="inv-wrap-search">
            <v-text-field
              class="inv-search-field"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
              @input="typing = true"
            >
            </v-text-field>
          </v-flex>
          <v-layout xs6>
            <v-btn
              v-if="!showFilters"
              text
              class="mt-4 mx-2 px-2 dialog-btn"
              @click.native="showFilters = !showFilters"
            >
              <v-icon class="mr-2">filter_list</v-icon>
              <span style="text-transform: none; color: #00838F;"
                >Show Filters</span
              ></v-btn
            >
            <template v-else>
              <v-btn
                text
                class="mt-4 mx-2 px-2 dialog-btn"
                @click.native="showFilters = !showFilters"
              >
                <v-icon class="mr-2">filter_list</v-icon>
                <span style="text-transform: none; color: #00838F;"
                  >Hide Filters</span
                ></v-btn
              >
            </template>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              dark
              class="ml-2 my-2 mr-0"
              @click.native="addNewStaffModal"
            >
              <v-icon left>person_add</v-icon>
              Add New
            </v-btn>
          </v-layout>
        </v-layout>
        <v-layout v-if="showFilters" xs12 class="mt-2">
          <v-flex d-flex style="max-width: 170px; min-width: 170px;">
            <v-select
              :items="statuses"
              v-model="selectedStatuses"
              label="Status"
              multiple
              placeholder="Please Select"
            >
              <template slot="selection" slot-scope="{ item, index }">
                <span class="mr-1" v-if="index === 0">{{ item }}</span>
                <span v-if="index === 1" class="grey--text caption"
                  >(+{{ selectedStatuses.length - 1 }} others)</span
                >
              </template>
            </v-select>
          </v-flex>
          <v-flex
            class="ml-2"
            d-flex
            style="max-width: 180px; min-width: 161px;"
          >
            <v-select
              :items="roles"
              v-model="selectedRoles"
              label="Role"
              multiple
              return-object
              item-text="name"
              item-value="value"
              placeholder="Please Select"
            >
              <template slot="selection" slot-scope="{ item, index }">
                <span class="mr-1" v-if="index === 0">{{ item.name }}</span>
                <span v-if="index === 1" class="grey--text caption"
                  >(+{{ selectedRoles.length - 1 }} others)</span
                >
              </template>
            </v-select>
          </v-flex>
          <v-flex flex-grow-1 style="max-width: 70px;">
            <v-btn
              large
              color="#00838F"
              dark
              class="ml-2 mt-1 mr-0"
              style="min-width: 50px; padding: 0 10px;"
              @click.native="go"
            >
              Go
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-if="showFilters" xs12>
          <v-flex d-flex style="max-width: 100px;">
            <span class="mt-0 ml-0 clear-filters" @click="clearFilters"
              >Clear Filters</span
            >
          </v-flex>
        </v-layout>
      </v-flex>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          loader-height="2"
          :footer-props="{'items-per-page-options': [10, 20, 50, 100]}"
          class="elevation-1 table-org my-sticky-last-column-table"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr @click="view(item.id)" class="pointer items-body-row">
              <td style="min-width: 80px;">
                <v-icon
                  :color="setColor(item.status)"
                  style="font-size:13px;"
                >
                  fiber_manual_record
                </v-icon>
                <v-menu
                  offset-y
                  v-if="user_role === 'owner'"
                  @click.native.stop=""
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon class="rotate-icon">
                      <v-icon style="color: #999;">arrow_drop_down</v-icon>
                    </v-btn>
                  </template>

                  <v-list class="pa-0">
                    <v-list-item @click="changeStatusModal(item)">
                      <v-list-item-title v-if="item.status === 'active'"
                        >Deactivate
                      </v-list-item-title>
                      <v-list-item-title v-else>Activate</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
              <td>
                <v-avatar size="30" :color="!no_data.includes(item.color) ? item.color : primary" class="pointer">
                  <img v-if="!no_data.includes(item.avatar)" :src="item.avatar" alt="Staff Avatar" />
                  <span v-else-if="!no_data.includes(item.first_name) && !no_data.includes(item.last_name)" class="subtitle-2" style="color: #fff; margin-left: -1px; margin-bottom: -2px;">{{ `${item.first_name.charAt(0)}${item.last_name.charAt(0)}`}}</span>
                  <v-icon v-else size="22px" style="color: #fff; margin-left: -1px;">account_circle</v-icon>
                </v-avatar>
              </td>
              <td>{{ item.first_name }}</td>
              <td>{{ item.last_name }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.role }}</td>
              <td>
                <v-layout v-if="!no_data.includes(item.color)" class="align-center" style="min-width: 80px;">
                  <v-icon :color="item.color" style="font-size:16px;">fiber_manual_record</v-icon>&nbsp;<v-flex>{{ item.color }}</v-flex>
                </v-layout>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-flex style="min-width: 50px;">
                  <v-flex
                    @click.stop="view(item.id)"
                    class="action-link"
                    >View
                    <v-icon>visibility</v-icon>
                  </v-flex>
                </v-flex>
              </td>
            </tr>
          </template>
          <template
            slot="no-data"
            v-if="error_code == 404 || error_code == 500"
          >
            <v-btn color="primary" @click="initialize()">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="changeStatusDialog" max-width="500px" persistent>
        <v-card class="pa-4">
          <!-- Deactivate Staff -->
          <template v-if="this.selectedItem.status === 'active'">
            <v-card-title class="px-4">
              <h2 class="title">Deactivate Staff</h2>
            </v-card-title>
            <div class="change-status-body px-4 pb-4 pt-2">
              <div class="text-body-2">Are you sure you want to deactivate staff member?</div>
              <v-alert
                class="pa-2 mt-4 mb-0"
                outlined
                color="info"
                icon="lightbulb"
              >
                <span class="caption">Before deactivating a staff member, we recommend reassigning 
                  all client locations and jobs to another tech at once. 
                  To do so, please go to Scheduler > Schedule > Actions > Change Tech
                </span>
              </v-alert>
              <v-alert
                class="pa-2 mt-4"
                :value="!serverValidation"
                outlined
                color="error"
                icon="priority_high"
                transition="scale-transition"
              >
                <span class="caption">{{ serverValidationMessage }}</span>
              </v-alert>
            </div>
            <v-card-actions class="px-4">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="closeChangeStatus"
                >Cancel</v-btn
              >
              <v-btn
                color="primary"
                :loading="changeStatusLoading"
                :disabled="changeStatusLoading"
                @click="changeStatus(selectedItem.id, 'non-active')"
              >
                Deactivate
              </v-btn>
            </v-card-actions>
          </template>

          <!-- Activate Staff -->
          <template v-else>
            <v-card-title class="px-4">
              <h2 class="title">Activate Staff</h2>
            </v-card-title>
            <div class="change-status-body px-4 pb-4 pt-2">
              <div class="text-body-2">Are you sure you want to activate staff member?</div>
              <v-alert
                class="pa-2 mt-4"
                :value="!serverValidation"
                outlined
                color="error"
                icon="priority_high"
                transition="scale-transition"
              >
                <span class="caption">{{ serverValidationMessage }}</span>
              </v-alert>
            </div>
            <v-card-actions class="px-4">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="closeChangeStatus"
                >Cancel</v-btn
              >
              <v-btn
                color="primary"
                :loading="changeStatusLoading"
                :disabled="changeStatusLoading"
                @click="changeStatus(selectedItem.id, 'active')"
                >Activate
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </v-dialog>

      <!-- Add New Staff Dialog -->
      <v-dialog
        v-if="addNewStaffDialod"
        v-model="addNewStaffDialod"
        max-width="500px"
        persistent
      >
        <v-card class="pa-4">
          <div>
            <v-card-title>
              <h2 class="title">Add New Staff Member</h2>
            </v-card-title>
            <div class="pa-4">
              <v-flex class="xs12 px-2">
                <v-text-field
                  label="First Name*"
                  v-model="addNewStaffData.first_name"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.addNewStaffData.first_name) ||
                      server_errors.first_name
                  "
                  @blur="$v.addNewStaffData.first_name.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex class="xs12 px-2">
                <v-text-field
                  label="Middle Name"
                  v-model="addNewStaffData.middle_name"
                  placeholder="Please Enter"
                  :error-messages="server_errors.middle_name"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex class="xs12 px-2">
                <v-text-field
                  label="Last Name*"
                  v-model="addNewStaffData.last_name"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.addNewStaffData.last_name) ||
                      server_errors.last_name
                  "
                  @blur="$v.addNewStaffData.last_name.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex class="xs12 px-2">
                <v-autocomplete
                  :items="
                    roles.filter(
                      i => roleHierarchy[user_role] <= roleHierarchy[i.value]
                    )
                  "
                  label="Role*"
                  item-text="name"
                  item-value="value"
                  v-model="addNewStaffData.role"
                  placeholder="Please Select"
                  :error-messages="
                    errors($v.addNewStaffData.role) || server_errors.role
                  "
                  @blur="$v.addNewStaffData.role.$touch()"
                  @focus="resetServerValidation"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                v-if="
                  !no_data.includes(addNewStaffData) &&
                  !no_data.includes(addNewStaffData.role) &&
                  addNewStaffData.role !== 'developer'
                " class="xs12 px-2">
                <v-alert dense outlined type="info" icon="info" class="mb-3">
                  <div class="body-2" style="color: rgba(0, 0, 0, 0.87)">
                    You will be charged for this staff member at the end of your billing cycle
                  </div>
                </v-alert>
              </v-flex>
              <v-flex class="xs12 px-2">
                <v-text-field
                  label="Email*"
                  v-model.trim="addNewStaffData.email"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.addNewStaffData.email) || server_errors.email
                  "
                  @blur="$v.addNewStaffData.email.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex class="xs12 px-2">
                <v-text-field
                  label="Cell Phone*"
                  v-model="addNewStaffData.phone"
                  v-mask="'(###) ### - ####'"
                  placeholder="Please Enter"
                  :error-messages="
                    errors($v.addNewStaffData.phone) || server_errors.phone
                  "
                  @blur="$v.addNewStaffData.phone.$touch()"
                  @focus="resetServerValidation"
                ></v-text-field>
              </v-flex>
              <v-flex class="xs12 px-2">
                <v-menu
                  id="add_staff_menu_hire_date"
                  ref="menu1"
                  label="Hire Date*"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  placeholder="Please Select"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      id="add_staff_text_hire_date"
                      v-on="on"
                      v-model="addNewStaffData.hire_date"
                      label="Hire Date*"
                      prepend-icon="event"
                      readonly
                      placeholder="Please Select"
                      :error-messages="
                        errors($v.addNewStaffData.hire_date) ||
                          server_errors.hire_date
                      "
                      @blur="$v.addNewStaffData.hire_date.$touch()"
                      @focus="resetServerValidation"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    id="edit_staff_picker_hire_date"
                    v-model="addNewStaffData.hire_date"
                    no-title
                    @input="menu1 = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex class="xs12 px-2">
                <v-menu
                  ref="menu3"
                  :close-on-content-click="false"
                  v-model="menu3"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="225px"
                  min-width="225px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      label="Color"
                      v-model="addNewStaffData.color"
                      placeholder="Please Enter"
                      :error-messages="server_errors.color"
                      @focus="colorPickerFocus(addNewStaffData.color)"
                    >
                      <template slot="prepend">
                        <v-icon :color="addNewStaffData.color || '#000000'">brightness_1</v-icon>
                      </template>
                    </v-text-field>
                  </template>
                  <v-color-picker
                    v-if="menu3"
                    mode="hexa"
                    v-model="addNewStaffData.color"
                    hide-mode-switch
                    @input="updateColorValue($event, 'addNewStaffData')"
                    style="border-bottom-right-radius: 0; border-bottom-left-radius: 0;"
                ></v-color-picker>
                  <v-card-actions class="white">
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="cancelUpdateColor('menu3', 'addNewStaffData')">Cancel</v-btn>
                      <v-btn color="primary" @click="menu3 = false">Ok</v-btn>
                  </v-card-actions> 
                </v-menu>
              </v-flex>
              <v-alert
                class="pa-2 mt-4"
                :value="$v.addNewStaffData.$error"
                outlined
                color="error"
                icon="priority_high"
                transition="scale-transition"
              >
                <span class="caption">Please fill out form correctly</span>
              </v-alert>
              <v-alert
                class="pa-2 mt-4"
                :value="!serverValidation"
                outlined
                color="error"
                icon="priority_high"
                transition="scale-transition"
              >
                <span class="caption">{{ serverValidationMessage }}</span>
              </v-alert>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="closeAddNewStaff"
                >Cancel</v-btn
              >
              <v-btn
                color="primary"
                :loading="saveAddStaffLoading"
                :disabled="saveAddStaffLoading"
                @click="addNewStaff"
                >Save
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service";
import { mapState, mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, helpers, email } from "vuelidate/lib/validators";
import { valMessages, getValMessage } from "@/common/error-messages";
import { mask } from 'vue-the-mask'

const validations = {
  addNewStaffData: {
    first_name: { required },
    last_name: { required },
    role: { required },
    email: { required, email },
    phone: { required, phone: v => !helpers.req(v) || /^\d{10}$/.test(v.replace(/[()-\s]/g, "")) },
    hire_date: { required }
  }
};

export default {
  mixins: [validationMixin],
  validations,
  directives: {mask},
  data: () => ({
    menu1: false,
    menu2: false,
    menu3: false,
    startingEditColor: '#000000',
    no_data: [null, "", undefined, "null"],
    dialog: false,
    dialogNew: false,
    changeStatusDialog: false,
    changeStatusLoading: false,
    validNew: true,
    validEdit: true,
    showFilters: false,
    addNewStaffDialod: false,
    editLoading: false,
    headers: [
      { text: "Status", value: "status", sort_column: 0 },
      { text: "Photo", value: "avatar", sortable: false },
      { text: "First Name", value: "first_name", sort_column: 1 },
      { text: "Last Name", value: "last_name", sort_column: 2 },
      { text: "Email", value: "email", sort_column: 3 },
      { text: "Role", value: "role", sort_column: 4 },
      { text: "Color", value: "color", sortable: false },
      { text: "Actions", sortable: false, align: "left" }
    ],
    items: [],
    editedIndex: -1,
    totalItems: 0,
    search: "",
    options: {},
    loading: false,
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "asc",
      status: null,
      roles: null
    },
    staffMember: {},
    indexMember: "",
    first_name_delete: "",
    last_name_delete: "",
    error_code: "",
    selectedItem: {},
    statuses: ["Active", "Inactive"],
    selectedStatuses: ["Active"],
    roles: [],
    selectedRoles: [],
    states: [],
    addNewStaffData: {
      first_name: "",
      middle_name: "",
      last_name: "",
      email: "",
      phone: "",
      username: "",
      role: "",
      hire_date: ""
    },
    roleHierarchy: {
      owner: 1,
      developer: 2,
      manager: 3,
      office_staff: 4,
      accountant: 5,
      crew_leader: 6,
      field_tech: 7
    },

    exportCsvLoading: false,
    saveAddStaffLoading: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),

  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        this.options.page = 1;
        this.initialize();
      }
    }, 1000)
  },
  mounted() {
    if (!this.no_data.includes(this.staffTableData)) {
      this.options = this.staffTableData.options
      this.tableData = this.staffTableData.tableData 
      this.search = this.staffTableData.tableData.search
      this.selectedStatuses = this.staffTableData.selectedStatuses
      this.selectedRoles = this.staffTableData.selectedRoles
      this.showFilters = this.staffTableData.showFilters
    }
    this.getRoles();
    this.getStates();
  },
  methods: {
    ...mapActions(["setTableData", "checkAuth", 'vEmit']),
    initialize() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        !this.no_data.includes(sortBy[0]) &&
        this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy[0]
        ).sort_column;
      }
      this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";

      this.tableData.length = itemsPerPage;

      this.tableData.page = page;
      this.tableData.search = this.search;
      this.tableData.draw++;
      this.draw = this.tableData.draw;

      if (this.selectedStatuses.length !== this.statuses.length) {
        this.tableData.status = this.selectedStatuses.map(status =>
          status.toLowerCase()
        );
      } else {
        this.tableData.status = _.values(this.statuses).map(status =>
          status.toLowerCase()
        );
      }
      if (this.selectedRoles.length !== this.roles.length) {
        this.tableData.roles = this.selectedRoles.map(role => role.value);
      } else {
        this.tableData.roles = this.roles.map(role => role.value);
      }

      let filtersForSaving = {
        tableData: _.cloneDeep(this.tableData),
        options: _.cloneDeep(this.options),
        selectedStatuses: _.cloneDeep(this.selectedStatuses),
        selectedRoles: _.cloneDeep(this.selectedRoles),
        showFilters: this.showFilters
      }
      filtersForSaving.tableData.draw = 0
      this.setTableData({key: 'staffTableData', value: filtersForSaving})

      ApiService.get("/employee", this.tableData).then(response => {
        let data = response.data;
        this.draw++;

        this.items = data.staff.data;
        this.totalItems = data.staff.total;
        this.loading = false;
      });
    },
    go() {
      this.options.page = 1
      this.initialize()
    },
    getRoles() {
      ApiService.get("/roles").then(response => {
        let roles = response.data.roles
        if (
          !this.no_data.includes(roles) &&
          Array.isArray(roles)
        ) {
          if (roles.some(i => i.value === "accountant")) {
            let item = roles.find(r => r.value === "accountant")
            roles = roles.filter(r => r.value !== "accountant")
            roles.push(item)
          }
          if (roles.some(i => i.value === "developer")) {
            let item = roles.find(r => r.value === "developer")
            roles = roles.filter(r => r.value !== "developer")
            roles.unshift(item)
          }
        }
        this.roles = roles
        this.selectedRoles = roles
        this.initialize();
      });
    },
    getStates() {
      ApiService.get("/states").then(response => {
        this.states = response.data.states;
      });
    },
    changeStatusModal(item) {
      const index = this.items.indexOf(item)
      this.selectedItem = item
      this.resetServerValidation()
      this.changeStatusLoading = false
      this.changeStatusDialog = true
    },
    changeStatus(id, status) {
      let data = {
        id,
        status
      };
      let successText = "";
      status === "non-active"
        ? (successText = "Staff member has been successfully deactivated.")
        : (successText = "Staff member has been successfully activated.");
      this.changeStatusLoading = true
      ApiService.post("/employee_status", data)
        .then(response => {
          this.initialize();
          this.vEmit({ 
            name: "notification", 
            data: {
              status: "success",
              text: successText
            }
          });
          this.checkAuth()
          this.changeStatusLoading = false
          this.closeChangeStatus()
        })
        .catch(({ response }) => {
          this.changeStatusLoading = false
          this.serverValidation = false;
          if (response.data.error) {
            this.serverValidationMessage = this.titleCase(
              response.data.error
            );
          }
          if (response.data.message) {
            this.serverValidationMessage = response.data.message;
          }
          if (response.data.errors) {
            this.server_errors = response.data.errors;
          }
        });
    },
    closeChangeStatus() {
      this.changeStatusDialog = false;
    },
    addNewStaffModal() {
      Object.keys(this.addNewStaffData).forEach(
        v => (this.addNewStaffData[v] = "")
      );
      this.addNewStaffData.color = "#000000"
      this.$v.$reset();
      this.resetServerValidation();
      this.addNewStaffDialod = true;
    },
    addNewStaff() {
      this.resetServerValidation();
      this.$v.addNewStaffData.$touch();
      if (!this.$v.addNewStaffData.$invalid) {
        this.saveAddStaffLoading = true;
        let data = _.cloneDeep(this.addNewStaffData)
        if(!this.no_data.includes(data.phone)) {
          data.phone = this.phoneWithoutMask(data.phone)
        }
        ApiService.post("/employee", data)
          .then(resposne => {
            this.initialize();
            this.vEmit({ 
              name: "notification", 
              data: {
                status: "success",
                text: "New staff member has been successfully added."
              }
            });
            this.checkAuth()
            this.saveAddStaffLoading = false;
            this.closeAddNewStaff();
          })
          .catch(({ response }) => {
            this.saveAddStaffLoading = false;
            this.serverValidation = false;
            if (response.data.error) {
              this.serverValidationMessage = this.titleCase(
                response.data.error
              );
            }
            if (response.data.message) {
              this.serverValidationMessage = response.data.message;
            }
            if (response.data.errors) {
              this.server_errors = response.data.errors;
            }
          });
      }
    },
    closeAddNewStaff() {
      this.addNewStaffDialod = false;
    },
    exportCsv() {
      this.exportCsvLoading = true;
      ApiService.get("/employee_select_list")
        .then(response => {
          let items = response.data.staff;
          let csvContent = "";
          let headers =
            '"Name","Email","Phone","Color"\n';
          let csvData = [];
          items.forEach(i => {
            let row = {
              name: `"${
                !this.no_data.includes(i.name) ? i.name : ""
              }"`,
              email: `"${
                !this.no_data.includes(i.email) ? i.email : ""
              }"`,
              phone: `"${
                !this.no_data.includes(i.phone) ? this.displayPhone(i.phone) : ""
              }"`,
              color: `"${
                !this.no_data.includes(i.color) ? i.color : ""
              }"`
            };
            csvData.push(row);
          });

          csvContent += headers;
          csvContent += csvData
            .map(item => Object.values(item).join(","))
            .join("\n");
          csvContent = csvContent.replace(/(^\[)|(\]$)/gm, "");
          const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
          const url = URL.createObjectURL(data)
          const link = document.createElement("a");
          link.setAttribute("href", url);
          link.setAttribute("download", "Staff List.csv");
          link.click();

          this.exportCsvLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.exportCsvLoading = false;
          this.vEmit({ 
            name: "notification", 
            data: {
              status: "error",
              text: "Oops something went wrong..."
            }
          });
        });
    },
    clearFilters() {
      this.selectedStatuses = ["Active"]
      this.selectedRoles = this.roles
      this.options.page = 1
      this.initialize()
    },
    setColor(status) {
      if (status == "active" || status == "1") return "green";
      return "red";
    },
    view(id) {
      this.$router.push("/staff/" + id + "/show");
    },
    displayPhone (phone) {
      if(/^\d{10}$/.test(phone)) {
          return `(${phone.substr(0, 3)}) ${phone.substr(3, 3)} - ${phone.substr(6, 4)}`
      } else {
          return phone
      }
    },
    justNumbers(str) {
      if (typeof str === "string") {
        return str.replace(/\D+/g, "");
      } else {
        return str;
      }
    },
    phoneWithoutMask (phone) {
      if(phone && typeof phone === 'string') {
          return phone.replace(/[()-\s]/g, "")
      } else {
          return phone
      }
    },
    colorPickerFocus(color) {
      this.startingEditColor = color
      this.resetServerValidation()
    },
    updateColorValue(input, name) {
      this[name].color = input
    },
    cancelUpdateColor(menuName, dataObjectName) {
      this[dataObjectName].color = this.startingEditColor
      this[menuName] = false
    },
    titleCase(str) {
      return _.upperFirst(str.replace(/_/g, " "));
    },
    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
      this.server_errors = {};
    },
    errors: getValMessage(valMessages)(validations),
  },
  computed: {
    ...mapGetters(['staffTableData']),
    ...mapState({
      user_role: state => state.auth.user.role
    })
  }
};
</script>
<style>
/**tools table**/
.staff-list-wrap div.datatable.table {
  margin-bottom: 0%;
}

.staff-list-wrap .header-search-single {
  padding-bottom: 20px;
}

/*Search field width*/
.search-org {
  min-width: 120px;
}

td a {
  text-decoration: none;
}

.dialog-heading {
  background-color: #efefef;
  padding: 10px;
}

.no-opacity {
  opacity: 0;
}

.clear-filters {
  text-transform: none;
  color: #00838F;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
}
</style>
